import type { Service, Stat, Testimonial } from '@/lib/index';
import { ROUTE_PATHS } from '@/lib/index';

// ─── Services Data ──────────────────────────────────────────────────────────
export const SERVICES: Service[] = [
  {
    id: 'web-design',
    slug: 'web-design',
    titleRo: 'Web Design',
    titleEn: 'Web Design',
    shortDescRo: 'Design personalizat pentru o experiență unică. Transformăm ideile dvs. în realitate digitală.',
    shortDescEn: 'Custom design for a unique experience. We transform your ideas into digital reality.',
    longDescRo: 'Cu un design personalizat, oportunitățile sunt nesfârșite. Echipa noastră specializată va lucra cu dvs. pentru a construi o soluție care să îndeplinească nevoile unice ale companiei dvs. și lucrează cu sârguință pentru a face posibil „imposibilul". Cu alte cuvinte, dacă ai o idee, găsim o modalitate de a o transforma în realitate.',
    longDescEn: 'With custom design, the opportunities are endless. Our specialized team will work with you to build a solution that meets your company\'s unique needs and works diligently to make the "impossible" possible. In other words, if you have an idea, we find a way to make it reality.',
    icon: '🖥️',
    image: 'https://images.unsplash.com/photo-1551033406-611cf9a28f67?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080',
    features: [
      { ro: 'Design responsive pentru toate dispozitivele', en: 'Responsive design for all devices' },
      { ro: 'Optimizare SEO completă', en: 'Complete SEO optimization' },
      { ro: 'Animații și efecte vizuale avansate', en: 'Advanced animations and visual effects' },
      { ro: 'Integrare CMS și platforme eCommerce', en: 'CMS and eCommerce platform integration' },
      { ro: 'Suport și mentenanță continuă', en: 'Continuous support and maintenance' },
      { ro: 'Performanță și viteză optimizată', en: 'Optimized performance and speed' },
    ],
    route: ROUTE_PATHS.WEB_DESIGN,
  },
  {
    id: 'call-center',
    slug: 'call-center',
    titleRo: 'Call Center',
    titleEn: 'Call Center',
    shortDescRo: 'Soluții complete pentru call center. Asistența telefonică rămâne cel mai popular canal de suport.',
    shortDescEn: 'Complete call center solutions. Phone support remains the most popular support channel.',
    longDescRo: 'Asistența telefonică pentru clienți rămâne unul dintre cele mai populare canale de asistență. Înseamnă că centrele de apeluri sunt la fel de importante ca întotdeauna. Ca urmare a acestui fapt, oferim soluții menite să ajute un centru de apeluri să funcționeze fără probleme.',
    longDescEn: 'Phone customer support remains one of the most popular support channels. This means that call centers are as important as ever. As a result, we offer solutions designed to help a call center run smoothly.',
    icon: '📞',
    image: 'https://images.unsplash.com/photo-1563206767-5b18f218e8de?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080',
    features: [
      { ro: 'Sisteme ACD și IVR avansate', en: 'Advanced ACD and IVR systems' },
      { ro: 'Înregistrare și monitorizare apeluri', en: 'Call recording and monitoring' },
      { ro: 'Raportare și statistici în timp real', en: 'Real-time reporting and statistics' },
      { ro: 'Integrare cu CRM și ticketing', en: 'CRM and ticketing integration' },
      { ro: 'Soluții omnichannel', en: 'Omnichannel solutions' },
      { ro: 'Scalabilitate și flexibilitate', en: 'Scalability and flexibility' },
    ],
    route: ROUTE_PATHS.CALL_CENTER,
  },
  {
    id: 'it-hardware',
    slug: 'it-hardware',
    titleRo: 'IT & Hardware',
    titleEn: 'IT & Hardware',
    shortDescRo: 'Magazin de echipamente IT & Networking. Identificăm și implementăm soluția IT adecvată.',
    shortDescEn: 'IT & Networking equipment store. We identify and implement the appropriate IT solution.',
    longDescRo: 'Selectarea furnizorului hardware IT în ziua de azi poate fi o sarcină cu nesfârșite opțiuni, de obicei înclinate spre cele mai recente și mai bune, nu spre ceea ce este cel mai bun interes al clientului. Sarcina de a identifica și implementa o soluție IT adecvată este scopul nostru principal.',
    longDescEn: 'Selecting an IT hardware supplier today can be a task with endless options, usually tilted towards the latest and greatest, not towards what is in the client\'s best interest. The task of identifying and implementing an appropriate IT solution is our primary goal.',
    icon: '🖧',
    image: 'https://images.unsplash.com/photo-1587202372634-32705e3bf49c?w=1200&q=80',
    features: [
      { ro: 'Servere și infrastructură de rețea', en: 'Servers and network infrastructure' },
      { ro: 'Echipamente Cisco, HP, Dell, Lenovo', en: 'Cisco, HP, Dell, Lenovo equipment' },
      { ro: 'Switch-uri, router-e, firewall-uri', en: 'Switches, routers, firewalls' },
      { ro: 'Soluții de stocare date', en: 'Data storage solutions' },
      { ro: 'Workstation-uri și laptopuri business', en: 'Business workstations and laptops' },
      { ro: 'Garanție și suport tehnic', en: 'Warranty and technical support' },
    ],
    route: ROUTE_PATHS.IT_HARDWARE,
  },
  {
    id: 'hosting',
    slug: 'gazduire',
    titleRo: 'Găzduire Premium',
    titleEn: 'Premium Hosting',
    shortDescRo: 'Soluții de găzduire premium pentru afacerea ta. VPS, Cloud și soluții dedicate.',
    shortDescEn: 'Premium hosting solutions for your business. VPS, Cloud and dedicated solutions.',
    longDescRo: 'Specializați în a găsi soluția optimă de găzduire care va asigura și garanta o expunere cât mai bună și rapidă a prezenței online pentru afacerea dvs. Oferim servere VPS, Soluții în Cloud, servere dedicate și multe altele pentru a asigura disponibilitate 99.9%.',
    longDescEn: 'Specialized in finding the optimal hosting solution that will ensure and guarantee the best and fastest online presence for your business. We offer VPS servers, Cloud Solutions, dedicated servers and much more to ensure 99.9% availability.',
    icon: '☁️',
    image: 'https://images.unsplash.com/photo-1660165458059-57cfb6cc87e5?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080',
    features: [
      { ro: 'Uptime garantat 99.9%', en: '99.9% guaranteed uptime' },
      { ro: 'Servere VPS și Dedicate', en: 'VPS and Dedicated Servers' },
      { ro: 'Soluții Cloud scalabile', en: 'Scalable Cloud solutions' },
      { ro: 'Certificat SSL inclus', en: 'SSL Certificate included' },
      { ro: 'Backup automat zilnic', en: 'Automatic daily backup' },
      { ro: 'Suport tehnic 24/7', en: '24/7 technical support' },
    ],
    route: ROUTE_PATHS.HOSTING,
  },
  {
    id: 'voip',
    slug: 'telefonie-voip',
    titleRo: 'Telefonie VoIP',
    titleEn: 'VoIP Telephony',
    shortDescRo: 'Telefonie VoIP de ultimă generație. Interconectivitate crescută și costuri reduse.',
    shortDescEn: 'Next-generation VoIP telephony. Increased interconnectivity and reduced costs.',
    longDescRo: 'Avantajele soluțiilor de telefonie VoIP sunt interconectivitate crescută între mediul online și cel offline, monitorizare și tracking îmbunătățite, integrabilitatea cu sistemele de tip CRM. Toate acestea vor aduce un plus de valoare afacerii dvs. ajutându-vă să comunicați mai ușor cu clienții.',
    longDescEn: 'The advantages of VoIP telephony solutions are increased interconnectivity between the online and offline environment, improved monitoring and tracking, integrability with CRM-type systems. All of these will add value to your business by helping you communicate more easily with customers.',
    icon: '📡',
    image: 'https://images.unsplash.com/photo-1604591259403-81d6c9cf87d7?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080',
    features: [
      { ro: 'Reducere costuri telefonie până la 70%', en: 'Phone cost reduction up to 70%' },
      { ro: 'Integrare cu sisteme CRM', en: 'Integration with CRM systems' },
      { ro: 'Conferințe audio și video HD', en: 'HD audio and video conferencing' },
      { ro: 'Număr de telefon virtual național', en: 'National virtual phone number' },
      { ro: 'Aplicație mobilă și desktop', en: 'Mobile and desktop application' },
      { ro: 'Înregistrare și analiză apeluri', en: 'Call recording and analysis' },
    ],
    route: ROUTE_PATHS.VOIP,
  },
  {
    id: 'crm-software',
    slug: 'crm-software',
    titleRo: 'CRM & Software',
    titleEn: 'CRM & Software',
    shortDescRo: 'Sisteme personalizate CRM și Software. Gestionați eficient clienții și informațiile.',
    shortDescEn: 'Custom CRM systems and Software. Efficiently manage customers and information.',
    longDescRo: 'Probabil cea mai importantă parte din afacere este gestiunea informațiilor, fie că vorbim de gestiunea de client sau stocuri de materiale, sistemele dezvoltate de noi vin în întâmpinarea nevoilor dvs. reale. Soluții personalizate pentru fiecare tip de business.',
    longDescEn: 'Probably the most important part of a business is information management, whether we are talking about customer management or material stocks, the systems we develop meet your real needs. Customized solutions for every type of business.',
    icon: '⚙️',
    image: '/crm-service.webp',
    features: [
      { ro: 'CRM personalizat pentru business-ul dvs.', en: 'CRM customized for your business' },
      { ro: 'Gestiune stocuri și inventar', en: 'Stock and inventory management' },
      { ro: 'Module de facturare și contabilitate', en: 'Invoicing and accounting modules' },
      { ro: 'Rapoarte și analize business', en: 'Business reports and analyses' },
      { ro: 'Aplicații web și mobile', en: 'Web and mobile applications' },
      { ro: 'Integrări API cu platforme externe', en: 'API integrations with external platforms' },
    ],
    route: ROUTE_PATHS.CRM_SOFTWARE,
  },
];

// ─── Stats ───────────────────────────────────────────────────────────────────
export const STATS: Stat[] = [
  { value: '10+', labelRo: 'Ani de Experiență', labelEn: 'Years of Experience' },
  { value: '350+', labelRo: 'Clienți Mulțumiți', labelEn: 'Satisfied Clients' },
  { value: '400+', labelRo: 'Proiecte Finalizate', labelEn: 'Completed Projects' },
  { value: '99.9%', labelRo: 'Uptime Garantat', labelEn: 'Guaranteed Uptime' },
];

// ─── Testimonials ────────────────────────────────────────────────────────────
export const TESTIMONIALS: Testimonial[] = [
  {
    name: 'Alexandru Ionescu',
    role: 'Director General',
    company: 'TechCorp România',
    textRo: 'Interpersonal ne-a furnizat o soluție IT completă care a transformat modul în care operăm. Profesionalism, rapiditate și suport excelent.',
    textEn: 'Interpersonal provided us with a complete IT solution that transformed the way we operate. Professionalism, speed and excellent support.',
    avatar: 'AI',
  },
  {
    name: 'Maria Popescu',
    role: 'Manager IT',
    company: 'Distribo SRL',
    textRo: 'Site-ul dezvoltat de echipa Interpersonal a crescut vânzările noastre online cu 45%. Recomandăm cu toată încrederea!',
    textEn: 'The website developed by the Interpersonal team increased our online sales by 45%. We recommend with full confidence!',
    avatar: 'MP',
  },
  {
    name: 'Gheorghe Dumitrescu',
    role: 'CEO',
    company: 'CallPro Center',
    textRo: 'Sistemul de call center implementat funcționează impecabil. Echipa Interpersonal a înțeles exact ce aveam nevoie.',
    textEn: 'The implemented call center system works flawlessly. The Interpersonal team understood exactly what we needed.',
    avatar: 'GD',
  },
];

// ─── Nav Items ────────────────────────────────────────────────────────────────
export const NAV_ITEMS = [
  { labelRo: 'Acasă', labelEn: 'Home', route: ROUTE_PATHS.HOME },
  { labelRo: 'Web Design', labelEn: 'Web Design', route: ROUTE_PATHS.WEB_DESIGN },
  { labelRo: 'Call Center', labelEn: 'Call Center', route: ROUTE_PATHS.CALL_CENTER },
  { labelRo: 'IT & Hardware', labelEn: 'IT & Hardware', route: ROUTE_PATHS.IT_HARDWARE },
  { labelRo: 'Găzduire', labelEn: 'Hosting', route: ROUTE_PATHS.HOSTING },
  { labelRo: 'Telefonie VoIP', labelEn: 'VoIP Telephony', route: ROUTE_PATHS.VOIP },
  { labelRo: 'CRM & Software', labelEn: 'CRM & Software', route: ROUTE_PATHS.CRM_SOFTWARE },
  { labelRo: 'Contact', labelEn: 'Contact', route: ROUTE_PATHS.CONTACT },
];
